export enum SkillsManagementModalType {
  Create = "create",
  Import = "import",
  Edit = "edit",
  Merge = "merge"
}
